import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=5555faf6&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"
import style0 from "./Pay.scss?vue&type=style&index=0&id=5555faf6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5555faf6",
  null
  
)

export default component.exports